import { EligibilityCheckResult } from '../components/bills/bill-grid-components/archive-release-components/eligibility-status-modal';

export enum StatusStorageKeys {
  eligibilityCheckStatus = 'eligibilityCheckStatus',
  fileUploadStatus = 'fileUploadStatus',
}
export type StatusData = EligibilityCheckResult;

export function persistStatus<StatusData>(
  statusData: StatusData,
  storageKey: StatusStorageKeys,
  statusId: string,
): Record<string, StatusData> {
  const storedData = JSON.parse(localStorage.getItem(storageKey) || '{}');
  let currentStatuses: Record<string, StatusData>;

  if (Array.isArray(storedData)) {
    currentStatuses = storedData.reduce<Record<string, StatusData>>(
      (acc, item) => {
        const { statusId: id, taskId, ...rest } = item;
        acc[id ?? taskId] = rest;
        return acc;
      },
      {},
    );
  } else {
    currentStatuses = storedData;
  }
  currentStatuses[statusId] = {
    ...currentStatuses[statusId],
    ...statusData,
  };
  localStorage.setItem(storageKey, JSON.stringify(currentStatuses));
  return currentStatuses;
}

export function removeStatus(
  storageKey: StatusStorageKeys,
  statusId: string,
): Record<string, StatusData> {
  const storedData = JSON.parse(localStorage.getItem(storageKey) || '{}');
  if (storedData[statusId]) {
    delete storedData[statusId];
    localStorage.setItem(storageKey, JSON.stringify(storedData));
  }
  return storedData;
}
